/**
 * Function: Restrict type="number" inputs to allow only numbers from [0 - 9].
 * Purpose: Prevent special characters such as (., -, e) from being permitted in a number input.
 * Date: Tuesday, Novemeber 21, 2017.
 * Author: OJ
 */
export default function NumbersOnlyDirective() {
  return {
    restrict: 'A',
    link: (scope, element, attrs) => {
      const singleCharRegExp = RegExp(attrs.numbersOnly);
      const wholeWordRegExp = new RegExp(`^${attrs.numbersOnly}+$`);
      const ele = element[0];

      if (!ele) {
        console.warn('No element found for NumbersOnlyDirective');
        return;
      }

      // Fired on keydown
      ele.addEventListener('keydown', event => onKeydown(singleCharRegExp, event));

      // Fired on right click > paste
      ele.addEventListener('paste', event => onPaste(wholeWordRegExp, event));
    }
  };
}

function onKeydown(re, event) {
  const input = event.key;
  const exclude = /Backspace|Tab|Delete|Del|ArrowUp|Up|ArrowDown|Down|Control/;
  const isCopyPaste = (event.ctrlKey || event.metaKey) && ['c', 'v', 'x'].includes(input);

  if (!isCopyPaste && !exclude.test(input) && !re.test(input)) {
    event.preventDefault();
  }
}

function onPaste(re, event) {
  const input = (event.clipboardData || window.clipboardData).getData('text');

  if (!re.test(input)) {
    event.preventDefault();
  }
}
